import { compose } from 'recompose';
import HrCreateComment from './hrCreateComment';

const enhance = compose();
export default enhance(HrCreateComment);
